import { Key } from "./Key";

export const defaultPriceCountryCode = Key.language.default.toUpperCase();
export const defaultPriceNewProduct = 100;
